import React from 'react';
import PropTypes from 'prop-types';

const copyContent = function (originalContent) {
  if (typeof (originalContent) === 'object') {
    if (Array.isArray(originalContent)) {
      return originalContent.slice();
    }

    return Object.assign({}, originalContent);
  }

  return originalContent;
};

const DefinitionDescription = (
  {
    preprocessDefinitionDescriptions,
    hasNestedDefinitionList,
    classNames = [],
    children
  }
) => {
  const itemAttributes = {};
  let descriptionContent = copyContent(children);

  if (hasNestedDefinitionList) {
    classNames.push('has-nested-data-list');
  }

  if (classNames.length > 0) {
    itemAttributes.className = classNames.join(' ');
  }

  if (preprocessDefinitionDescriptions && !hasNestedDefinitionList) {
    descriptionContent = preprocessDefinitionDescriptions(descriptionContent);
  }

  return (
    <dd {...itemAttributes}>
      <div className='overflow-limiter'>
        {descriptionContent}
      </div>
    </dd>
  );
};

DefinitionDescription.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  preprocessDefinitionDescriptions: PropTypes.func,
  hasNestedDefinitionList: PropTypes.bool
};

export default DefinitionDescription;